require('./newsletter');
require('./cookies');
require('./dots');
require('./bookings');
require('./experts');
require('./bubbles');
require('./fadeupText');
require('./videoSlidersInstaStory');
require('./videos/index');
require('./projects-horizontal');
require('./projects-home-swiper');
require('./pinned-slider');
require('./circles');
require('./swiper-cards');
require('./hovered-boxes');
require('./tabs-circle-v2');
require('./boxes-tabs-slider');
require('./mouseover-shadow');
require('./customers-slide-v2');
require('./estimare');
require('./knowledge-hub');
require('./article-body');
require('./market-insights-explorer');
require('./hero-portfolio');



// WEBPACK FOOTER //
// ./resources/js/modules/index.js